
const API = "https://yummybites.onrender.com/api/v1"

export default API